// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1VtP2","choiceBoxes":"toolbarselects_choiceBoxes__1xEe7","simpleField":"toolbarselects_simpleField__3K4cg"};